import {ChoiceList, TextField} from "@shopify/polaris";
import React, { useCallback, useState } from "react";
import ShopifyModal from "../../../../components/ShopifyModal";
import intl from "../../../../i18n/intl";
const UpgradePlanModal = ({upgradeOpen,setUpgradeOpen,handleMageUpgrade}) => {
    const [loading,setLoading] = useState(false)
    const [selected, setSelected] = useState(['']);
    const [selectedErr,setSelectedErr] = useState(false)
    const handleChange = useCallback((value) => {
      setSelected(value)
      setSelectedErr(false)
    }, []);
    const [textareaValue,setTextareaValue] = useState('')
    const [textErr,setTextErr] = useState(false)
    const [textareaValueErr,setTextareaValueErr] = useState('feed_other')
    const onChangeValue = (val)=>{
      setTextareaValue(val)
      setTextErr(false)
      if (val === '') {
        setTextareaValueErr('feed_other feed_other_err')
      }else{
        setTextareaValueErr('feed_other')
      }
    }
    
    const handleSubmit = ()=>{
      let text = selected[0];
      if (text === '') {
        setSelectedErr(true)
        return
      }

      if (text === 'Other' && textareaValue === '') {
        // toggleToast('Please provide your feedback',true)
        setTextErr(true)
        setTextareaValueErr('feed_other feed_other_err')
        return
      }
      if (text === 'Other' && textareaValue !== '') {
        text = textareaValue
      }
      handleMageUpgrade(0,text)
      handleOff()
    }
    const handleOff = ()=>{
      setLoading(false)
      setTextareaValue('')
      setSelected([''])
      setUpgradeOpen()
      setTextErr(false)
      setTextareaValueErr('feed_other')
      setSelectedErr(false)
    }
  return (
    <div className="upgrade_new_feature">
      <ShopifyModal
        id="feedback-option-modal"
        open={upgradeOpen}
        onClose={() =>handleOff()}
        secondaryActions={{ content: intl.get("Cancel") }}
        primaryAction={{
          content: intl.get("Submit"),
          onAction: () => handleSubmit(),
          loading,
        }}
      >
        <div className="feed_option_modal">
          <div className="feed_option_dsc">
          Before you cancel, please let us know the main reason for your cancellation.
          </div>
          <div className="feed_option_select">
            <div className="feed_option_option">
            <ChoiceList
              choices={[
                {label: intl.get('The package did not help my business.'), value: 'The package did not help my business'},
                {label: intl.get('It lacks the features I need.'), value: 'It lacks the features I need'},
                {label: intl.get('The user experience is poor.'), value: 'The user experience is poor'},
                {label: intl.get('The package price is too expensive.'), value: 'The package price is too expensive'},
                {label: intl.get('I am just trying it out.'), value: 'I am just trying it out'},
                {label: intl.get('Other'), value:'Other'},
              ]}
              selected={selected}
              onChange={handleChange}
              error={selectedErr && intl.get('Select a reason')}
            />
            {selected.indexOf('Other') !== -1 && <div className={textareaValueErr}>
            <TextField
            label={intl.get("Please enter your feedback here, we would greatly appreciate it.")}
            value={textareaValue}
            error={textErr && intl.get('Please provide your feedback')}
            onChange={onChangeValue}
            multiline={4}
            maxLength={300}
            autoComplete="off"
          />
              {/* <textarea name="feed" value={textareaValue} onChange={(e)=>onChangeValue(e.target.value)} cols="30" maxLength={300} rows="5" placeholder="Please enter your feedback here, we would greatly appreciate it."></textarea> */}
              <span className="feed_num">{textareaValue.length}/300</span>
            </div>}
            </div>
          </div>
        </div>
      </ShopifyModal>
    </div>
  );
};

export default UpgradePlanModal;
